//redirection vers airside

window.location.replace('https://airside.previmeteo.net');


import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from "axios";
Vue.config.productionTip = false
import HighchartsVue from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import moment from 'moment'
import "moment/locale/fr"; // Importer le français

moment.locale('fr')

import { Directus } from '@directus/sdk';

const authApi = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_URI,
  showLoader: true,
});

//console.log("process.env.VUE_APP_AUTH_API_URI",process.env.VUE_APP_AUTH_API_URI);

const api = {
  login: (email, password) => authApi.post('/auth/local', { email, password }),
}

export default api;

const directus = new Directus(process.env.VUE_APP_DIRECTUS_URI);
Vue.prototype.$directus = directus


stockInit(Highcharts)

// change Highcharts default theme
import Highcharts from 'highcharts'

import * as darkTheme from '@/assets/theme/flatdark.json'
Highcharts.setOptions(darkTheme)

Vue.prototype.$axios = axios;

Vue.prototype.$moment = moment

Vue.use(HighchartsVue)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
